import { render, staticRenderFns } from "./alienmanage.vue?vue&type=template&id=5e9f0d1b&scoped=true&"
import script from "./alienmanage.vue?vue&type=script&lang=js&"
export * from "./alienmanage.vue?vue&type=script&lang=js&"
import style0 from "./alienmanage.vue?vue&type=style&index=0&id=5e9f0d1b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9f0d1b",
  null
  
)

export default component.exports